<form [formGroup]="form">
  <input [class.w-100]="!showSortDirection"
         [disabled]="disabled"
         [placeholder]="placeholder"
         formControlName="searchInput"
  />
  @if (showSortDirection) {
    <button class="sort-btn sort-btn-font-style" [matMenuTriggerFor]="menu" #t="matMenuTrigger">
      {{ generateLabel }}
      <mat-icon [svgIcon]="eSvgIcons.ANGLE_DOWN"></mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @for (item of sortOptions; track item.value) {
        <button class="sort-btn-font-style" mat-menu-item (click)="form.get('sortDir').setValue(item.value)">
            {{ item.text }}
        </button>
      }
    </mat-menu>
  }
</form>
